import {
    obtenirAdherent,
    obtenirTokenDroit,
    obtenirSyndic,
    obtenirProprietaire,
    obtenirMessages,
    obtenirDocuments,
    obtenirCopropriete,
    obtenirHistorique,
    obtenirListeProprietaires,
    obtenirBanques,
    obtenirCharges,
    obtenirChargesCourantes,
    obtenirFournisseurs,
    obtenirListeCivilites,
    obtenirListePays,
} from '../App_Code/API';
import { makeActionCreator } from '../App_Code/Utils';
import { exerciceCourant } from '../App_Code/ExeComptable';
import { ActGlo, ActAdh, ActCop, ActDoc, ActMes, ActPro, ActSyn } from '../App_Data/ActionTypes';
import PrestationAction from '../App_Data/PrestationAction';
import LibVisibilite from '../App_Data/LibVisibilite';
import TypeCommunication from '../App_Data/TypeCommunication';


export const resetStore = makeActionCreator(ActGlo.RESET_STORE);

function obtenirCommun(numAuto, dispatch) {
    dispatch({ type: ActGlo.CHANGE_COP_SEL, data: numAuto });

    obtenirSyndic().then((syn) => {
        dispatch({ type: ActSyn.SYN_AJOUT, data: syn });
    });

    obtenirProprietaire().then((pro) => {
        dispatch({ type: ActPro.PRO_AJOUT, data: pro });
    });

    obtenirDocuments().then((docs) => {
        const docsMap = !docs
            ? undefined
            : docs.map((doc) => {
                const CorrespondanceP = PrestationAction.find(prest => prest.code === doc.Prest);
                const Prest = CorrespondanceP ? CorrespondanceP.text : doc.Prest;
                const CorrespondanceA = CorrespondanceP
                    ? CorrespondanceP.Act.find(act => act.code === doc.Act)
                    : undefined;
                const Act = CorrespondanceA ? CorrespondanceA.text : doc.Act;
                const Type = TypeCommunication(doc.Type, doc.Mode);
                const Visibilite = LibVisibilite(doc.VisiblePar);
                return {
                    ...doc,
                    Prest,
                    Act,
                    TypeLib: Type,
                    VisiblePar: Visibilite,
                };
            });

        dispatch({ type: ActDoc.DOC_AJOUT, data: docsMap });
    });

    obtenirMessages().then((messages) => {
        dispatch({ type: ActMes.MES_AJOUT, data: messages });
    });

    obtenirCopropriete().then((cop) => {
        const DateDebExeCourant = cop && cop.LsExercices && cop.LsExercices.length > 0 ? exerciceCourant(cop.LsExercices).DateDeb : new Date(new Date().getFullYear(), 0, 1);
        const NumExeCourant =  cop && cop.LsExercices && cop.LsExercices.length > 0 ? exerciceCourant(cop.LsExercices).Num : 0
        dispatch({
            type: ActCop.COP_AJOUT,
            data: cop ? { ...cop, DateDebExeCourant, NumExeCourant } : undefined,
        });
    });
}

export function chargementComplet() {
    return (dispatch) => {
        obtenirAdherent().then((adh) => {
            dispatch({ type: ActAdh.ADH_AJOUT, data: adh });
            const droit = sessionStorage.getItem('droit');
            if (adh && droit) {
                const numAuto = parseInt(droit.split('@')[1], 10);
                obtenirCommun(numAuto, dispatch);
            }
        });
    };
}

export function chargementCommun() {
    return (dispatch) => {
        const droit = sessionStorage.getItem('droit');
        const numAuto = parseInt(droit.split('@')[1], 10);
        obtenirCommun(numAuto, dispatch);
    };
}

export function ajoutCopro(numAuto) {
    return (dispatch) => {
        dispatch({ type: ActGlo.RESET_STORE });

        obtenirAdherent().then((adh) => {
            dispatch({ type: ActAdh.ADH_AJOUT, data: adh });
            obtenirCommun(numAuto, dispatch);
        });
    };
}

export function changementCopSel(numAuto) {
    return (dispatch) => {
        obtenirTokenDroit(numAuto).then((droit) => {
            sessionStorage.setItem('droit', droit);
            obtenirCommun(numAuto, dispatch);
                    });
    };
}

export function chargementArrierePlan() {
    return (dispatch) => {
        obtenirHistorique().then((historique) => {
            dispatch({ type: ActPro.PRO_HISTORIQUE_AJOUT, data: historique });
        });

        // obtenirListeProprietaires().then((lsPro) => {
        //     dispatch({ type: ActCop.COP_PROPRIETAIRES_AJOUT, data: lsPro });
        // });

        obtenirBanques().then((banques) => {
            dispatch({ type: ActCop.COP_BANQUE_AJOUT, data: banques });
        });
        
        // obtenirCharges(0).then((charges) => {
        //     dispatch({ type: ActCop.COP_CHARGES_AJOUT, data: charges });
        //     dispatch({ type: ActCop.COP_NUMEXE_MODIF, data: 0 });
        // });

        obtenirFournisseurs().then((fournisseurs) => {
            dispatch({ type: ActCop.COP_FOURNISSEURS_AJOUT, data: fournisseurs });
        });

        obtenirListeCivilites().then((civilites) => {
            const lsCivilites = !civilites
                ? []
                : civilites.slice(1).map(civilite => ({
                    label: civilite.NomCourt,
                    value: civilite.NomCourt,
                }));
            dispatch({ type: ActPro.PRO_CIVILITES_AJOUT, data: lsCivilites });
        });

        obtenirListePays().then((dpays) => {
            const lsPays = !dpays
                ? []
                : dpays.map(pays => ({
                    label: pays.LibEtendu,
                    value: pays.Code,
                }));
            dispatch({ type: ActPro.PRO_PAYS_AJOUT, data: lsPays });
        });
    };
}

export function chargeLsProprietaires() {
    return (dispatch) => {
         obtenirListeProprietaires().then((lsPro) => {
             dispatch({ type: ActCop.COP_PROPRIETAIRES_AJOUT, data: lsPro });
        });
    }
}

export function obtenirChargesExeCourant() {
    return (dispatch) => {
        dispatch({ type: ActCop.COP_CHARGES_AJOUT, data: ActGlo.EN_COURS_DE_CHARGEMENT });

        obtenirChargesCourantes().then((charges) => {
            dispatch({ type: ActCop.COP_CHARGES_AJOUT, data: charges });
        });
    }
}

export function obtenirChargesExe(Num) {
    return (dispatch) => {
        dispatch({ type: ActCop.COP_CHARGES_AJOUT, data: ActGlo.EN_COURS_DE_CHARGEMENT });

        obtenirCharges(Num).then((charges) => {
            dispatch({ type: ActCop.COP_CHARGES_AJOUT, data: charges });
            dispatch({ type: ActCop.COP_NUMEXE_MODIF, data: Num });
        });
    }
}





// WEBPACK FOOTER //
// ./src/Actions/GlobalActions.js